const login = {
        title: String("Login"),
        welcomeMsg: String("Welcome to AgroUPAdvisor!"),
        credentialAsk: String("Enter your credentials"),
        rememberMe: String("Remember my credentials"),
        signInButton: String("Log in"),
        forgotPass: String("Have you forgotten your password?"),
        createNewAccount: String("Create new account"),
        resendEmail: String("Resend verification email"),
        forgotPassTitle: String("Have you forgotten your password?"),
        forgotPassDescription: String("Enter your email and you will receive an email so you can restore your password."),
        forgotPassButton: String("Send mail"),
        cancelButton: String("Close"),
        emailAlreadySent: String("An email with instructions to recover the password has been sent."),
        username: String("Username"),
        password: String("Password"),
        email: String("Email"),
        errorFieldRequired: String("This field is required"),
        errorInvalidLength: String("Minimum characters: "),
        errorCredentials: String("The user and/or password are incorrect."),
        errorFieldEmail: String("Invalid email."),
        adviceActiveAccount: String("This account has not yet been activated."),
        emailNotRegistered: String("The email is not associated with any user."),
};

export default login;